import { CapitalActionEntryType } from 'further-types/lp/capital-action';
import { CalendarDay } from 'further-ui/utils';
import { round, sumBy } from 'lodash';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { CapitalActionFormValues } from '../../hooks/useCapitalActionForm';
import useTransactionTypes from './useTransactionTypes';

export default function useReviewDetails({
  capitalActionId,
  entries,
  vehicleId,
  date,
}: {
  capitalActionId?: string;
  entries: CapitalActionFormValues['entries'];
  vehicleId: string;
  date: CalendarDay;
}) {
  const { setValue } = useFormContext<CapitalActionFormValues>();

  const { transactionTypes, investorsBreakdown } = useTransactionTypes({
    capitalActionId,
    vehicleId,
    entries,
    date,
  });

  useEffect(() => {
    setValue('transactions', transactionTypes);
  }, [transactionTypes]);

  const totalAmount = round(
    sumBy(entries, (entry) => {
      if (
        [
          CapitalActionEntryType.CapitalRefund,
          CapitalActionEntryType.CapitalDistribution,
        ].includes(entry.entryType)
      ) {
        return -entry.totalAmount;
      }

      return entry.totalAmount;
    }),
    2,
  );

  return {
    transactionTypes,
    investorsBreakdown,
    totalAmount,
  };
}
